import React from "react";
import { Form, InputNumber, Select } from "antd";
import NumInput from "../../../components/inputs/NumInput";

const CURRENCY_OPTIONS = [
  { value: "MNT", label: "MNT" },
  { value: "USD", label: "USD" },
  { value: "CNY", label: "CNY" },
  { value: "EUR", label: "EUR" },
];

export default function CompareSection() {
  return (
    <>
      <Form.Item label="Валютын төрөл" name="currencyTypes">
        <Select
          mode="multiple"
          options={CURRENCY_OPTIONS}
          placeholder="Сонгох"
        />
      </Form.Item>

      <Form.Item label="Карт дахин захиалах хураамж (₮)" name="reOrderFee">
        <NumInput min={0} placeholder="0" />
      </Form.Item>

      <Form.Item label="Хүргэлтийн хураамж (₮)" name="deliveryFee">
        <NumInput min={0} placeholder="0" />
      </Form.Item>

      <Form.Item label="ATM татах хязгаар (₮)" name="atmWithdrawalLimit">
        <NumInput min={0} placeholder="0" />
      </Form.Item>

      <Form.Item
        label="Гадаад гүйлгээний шимтгэл (%)"
        name="foreignTransactionFee"
      >
        <NumInput min={0} max={100} step={0.01} placeholder="0.00" />
      </Form.Item>

      <Form.Item label="Дотоод гүйлгээний шимтгэл (%)" name="transactionFee">
        <NumInput min={0} max={100} step={0.1} placeholder="0.0" />
      </Form.Item>

      <Form.Item label="Худалдан авалтын хязгаар (₮)" name="purchaseLimit">
        <NumInput min={0} placeholder="0" />
      </Form.Item>

      <Form.Item label="Хамтрагч байгууллагын тоо" name="benefitMerchantCount">
        <NumInput min={0} placeholder="0" />
      </Form.Item>

      <Form.Item label="Буцаан олголтын хувь (%)" name="cashbackRate">
        <NumInput min={0} max={100} step={0.1} placeholder="0.0" />
      </Form.Item>

      <Form.Item label="Сарын хүү (%)" name="monthlyInterestRate">
        <NumInput min={0} max={100} step={0.01} placeholder="0.00" />
      </Form.Item>

      <Form.Item label="Зээлийн хязгаар — дээд (₮)" name="creditLimitMax">
        <NumInput min={0} placeholder="0" />
      </Form.Item>

      <Form.Item label="Зээлийн хязгаар — доод (₮)" name="creditLimitMin">
        <NumInput min={0} placeholder="0" />
      </Form.Item>
    </>
  );
}
